__turbopack_context__.v({
  "gradientOverlayBottom": "_-module__Co61KG__gradientOverlayBottom",
  "gradientOverlayTop": "_-module__Co61KG__gradientOverlayTop",
  "scrollbar": "_-module__Co61KG__scrollbar",
});
